var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.34 510.64",
    style: {
      enableBackground: "new 0 0 511.34 510.64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF4A55;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.02,0L256.02,0C115.01,0,0.7,114.31,0.7,255.32v0c0,141.01,114.31,255.32,255.32,255.32h0 c141.01,0,255.32-114.31,255.32-255.32v0C511.34,114.31,397.03,0,256.02,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.78,169.44L169.79,367.43c-7.24,7.24-18.99,7.24-26.24,0l0,0c-7.24-7.24-7.24-18.99,0-26.24l197.99-197.99 c7.24-7.24,18.99-7.24,26.24,0l0,0C375.03,150.45,375.03,162.2,367.78,169.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.55,367.43L143.55,169.44c-7.24-7.24-7.24-18.99,0-26.24l0,0c7.24-7.24,18.99-7.24,26.24,0L367.78,341.2 c7.24,7.24,7.24,18.99,0,26.24l0,0C360.54,374.68,348.79,374.68,341.55,367.43z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7c43f0746b3237751db12fe78c20ef7c.svg";
export { ForwardRef as ReactComponent };